/**
 * Generates a SHA-256 hash-based filename for cache-busting and deduplication.
 * Returns a 12-character hex prefix of the file's SHA-256 digest plus original extension.
 *
 * @param file - The file to hash
 * @returns Promise resolving to hashed filename (e.g., "a1b2c3d4e5f6.jpg")
 */
export default async function hashFileName(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 12);
  const ext = file.name.split('.').pop() || 'bin';
  return `${hashHex}.${ext}`;
}
